import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNoticeableIrritationSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M23.75 8C15.07 8 8 15.07 8 23.75S15.07 39.5 23.75 39.5 39.5 32.43 39.5 23.75 32.43 8 23.75 8Zm1.7 24.38c-.42 0-.7-.06-.94-.12a3.1 3.1 0 0 0-.76-.09c-.35 0-.53.04-.74.09-.23.06-.5.12-.96.12-1.19 0-2.12-.93-2.12-2.12 0-1.17.95-2.12 2.12-2.12.42 0 .68.06.92.11.23.05.43.1.78.1.33 0 .51-.04.72-.09.24-.06.51-.12.98-.12 1.17 0 2.12.95 2.12 2.12 0 1.15-.97 2.12-2.12 2.12Z",
    fill: "currentColor"
  }));
}

export { SvgNoticeableIrritationSelectedEmojiSecondary as default };
